import { render, staticRenderFns } from "./CounterComponent.vue?vue&type=template&id=5e881a34&"
import script from "./CounterComponent.vue?vue&type=script&lang=js&"
export * from "./CounterComponent.vue?vue&type=script&lang=js&"
import style0 from "./CounterComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports